import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from '../signup/service/signup.service';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import {BroadcastService} from "@azure/msal-angular";
import { MsalService} from "@azure/msal-angular";

@Component({
  selector: 'app-ms-signup-success',
  templateUrl: './ms-signup-success.component.html',
  styleUrls: ['./ms-signup-success.component.scss']
})
export class MsSignupSuccessComponent implements OnInit {

  signUpSuccess= false;
  isSignupError= false;
  signUpErrorMessage: string;
  public userInfo: any = null;

  constructor(private signupService: SignupService,
              private router: Router,
              private activeRoute: ActivatedRoute,
              private spinnerService: NgxSpinnerService,
              private localStorageService: LocalStorageService,
              private broadcastService: BroadcastService,
              private authService : MsalService) { }

  ngOnInit() {
      const clientObject = {};

      //const clientName =  this.activeRoute.snapshot.params.contactName;
      //const contactName = this.activeRoute.snapshot.params.contactName;
      //const contactEmail= this.activeRoute.snapshot.params.contactEmail;
      //const contactPhone= this.activeRoute.snapshot.params.contactPhone;

      // const clientName =  this.localStorageService.getMSUserDisplayName();
      // const contactName = this.localStorageService.getMSUserDisplayName();
      // const contactEmail= this.localStorageService.getMSUserEmail();
      // const contactPhone= '';

      this.userInfo = this.authService.getUser();

      console.log('-------Inside signup success-------');

      console.log(this.userInfo);

      const clientName =  this.userInfo.name === undefined ? 'Customer' : this.userInfo.name;
      const contactName = this.userInfo.name === undefined ? 'User' : this.userInfo.name;
      const contactEmail= this.userInfo.displayableId;
      const contactPhone= '';

      const signUpObject = {contactName: contactName, contactEmail: contactEmail,
                            clientName: clientName, contactPhone: contactPhone,
                            clientType: 'MS_USER',
                           };

       console.log(signUpObject);
      this.registerClient(signUpObject);
  }

  registerClient(signUpObject) {

         this.spinnerService.show();

          this.signupService.signup(signUpObject).subscribe(response => {
             let code = response.code;
             console.log(response);
             if (code === '200' || code === 200) {
                 this.localStorageService.removeCustomerId();
                 this.localStorageService.saveCustomerId(response.object.id);
                 this.spinnerService.hide();
                 this.signUpSuccess = true;
                 //this.router.navigate(['subscription-plans']);
                 this.router.navigate(['signup-success']);

             } else {
                 this.isSignupError =  true;
                 this.signUpErrorMessage = response.message;
                 this.spinnerService.hide();
             }
         },
           err => {
                console.log(err);
                this.isSignupError =  true;
                this.signUpErrorMessage = err.errorMessage;
                this.spinnerService.hide();
         });
  }

}



// WEBPACK FOOTER //
// ./src/app/ms-signup-success/ms-signup-success.component.ts